/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export function UnknownEmailSenderTableAction(cellContent, row, rowIndex) {
  return (
    <>
      {row.errorType == "Cant find account by sender" && (
        <OverlayTrigger
          overlay={<Tooltip id="specs-edit-tooltip">Create account</Tooltip>}
        >
          {
            <a
              className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
              onClick={() => {
                return window.open(
                  "/create-account/" +
                    row.accountId +
                    "/" +
                    row.systemUserType +
                    "/" +
                    row.fileUrl,
                  "_blank"
                );

                return {};
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Communication/Write.svg"
                  )}
                />
              </span>
            </a>
          }
        </OverlayTrigger>
      )}
    </>
  );
}

export const UnknownEmailErrorType = (cellContent, row, rowIndex) => (
  <>
    {cellContent != undefined && cellContent == 1 && (
      <span>Cant find account by sender</span>
    )}
    {cellContent != undefined && cellContent == 2 && (
      <span>Original Email sender cant be found</span>
    )}
    <> </>
  </>

  // <>
  //   {cellContent.errorType == 1 && <span>Cant find account by sender</span>}

  //   {cellContent.errorType == 2 && (
  //     <span>Original Email sender cant be found</span>
  //   )}
  //   <> </>
  // </>
);
